import { render, staticRenderFns } from "./OnFilters.vue?vue&type=template&id=35c7f21c&scoped=true&"
import script from "./OnFilters.vue?vue&type=script&lang=js&"
export * from "./OnFilters.vue?vue&type=script&lang=js&"
import style0 from "./OnFilters.vue?vue&type=style&index=0&id=35c7f21c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c7f21c",
  null
  
)

export default component.exports